var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-form-group',{attrs:{"label":_vm.label}},[_c('b-form-rating',{attrs:{"stars":"4","value":_vm.value,"variant":"accent","readonly":_vm.readonly},on:{"change":function($event){return _vm.$emit('change', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }